import {useState} from "react";
import {message} from "antd";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {b64DecodeToUrl} from "utils/helpers";

export const useTicketExport = () => {
    const {t} = useTranslation(["tickets"]);
    const stores = useStore();
    const [exporting, setExporting] = useState(false);

    const exportTickets = async params => {
        const messageKey = "ticket-export";
        message.loading({content: t("list.excel.preparing", {ns: "tickets"}), key: messageKey});
        setExporting(true);
        try {
            const response = await stores.ticketStore.exportTickets(params);
            if (!response?.base64Excel) {
                throw new Error("empty export");
            }
            const link = document.createElement("a");
            link.href = await b64DecodeToUrl(response.base64Excel);
            link.setAttribute(
                "download",
                `${t("list.excel.fileName", {ns: "tickets"})}-${moment().format(
                    "YYYY-MM-DD-HH-mm-ss"
                )}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
            message.success({
                content: t("list.excel.done", {ns: "tickets"}),
                key: messageKey,
                duration: 4
            });
        } catch (error) {
            message.error({
                content: t("list.excel.error", {ns: "tickets"}),
                key: messageKey,
                duration: 4
            });
        } finally {
            setExporting(false);
        }
    };

    return [exporting, exportTickets];
};
